<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<talent-info :row="row">
			<popover @refresh="refresh" :row="row" v-if="!['0', '2'].includes(row.is_effective) && !$isSp(row.platform_id)"></popover>
		</talent-info>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import talentInfo from '../../../components/talentInfo';
import popover from '@/views/talentCRM/myTalent/components/popover';
export default {
	components: {
		talentInfo,
		popover,
	},
	inject: ['refresh'],
	mixins: [mixin],
};
</script>
<style lang="less" scoped></style>
